import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_48 implements Validator {

	public static id = 'CTRL_48';
	private message = 'error.ctr_48';


	public LOG: LogService = new LogService(CTRL_48);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_48.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
	   const controls =
				this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

				const firstWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
				const secondWithStepId = ctrl.value.rgCtrls.secondChamp;
				const thirdWithStepId = ctrl.value.rgCtrls.thirdChamp;
				const fourthWithStepId = map.get(ctrl.value.rgCtrls.fourthChamp);
				const fifthWithStepId = map.get(ctrl.value.rgCtrls.fifthChamp);
				const sixthWithStepId = map.get(ctrl.value.rgCtrls.sixthChamp);
				const firstCtrl = form.controls[firstWithStepId];
				const fourthCtrl = form.controls[fourthWithStepId];
				const fifthCtrl = form.controls[fifthWithStepId];
				const sixthCtrl = form.controls[sixthWithStepId];

				let controlsName = [];
				const secondIters = this.formExtractorService.getIndexes(
								Array.from(controls.keys()), ['_SepAtt_pays'], secondWithStepId.split('INDEX')[0]);
				for (let i = 1; i <= secondIters.size; i++) {
								controlsName.push(secondWithStepId.replace('INDEX_48_1', i));
							}
				const valuesSecond = [];
				for (let i = 0; i < controlsName.length; i++) {
					valuesSecond.push(this.isFrance(form.controls[map.get(controlsName[i])].value));
				}

				controlsName = [];
				const thirdIters = this.formExtractorService.getIndexes(
								Array.from(controls.keys()), ['_SepAtt_pays'], thirdWithStepId.split('INDEX')[0]);
				for (let i = 1; i <= thirdIters.size; i++) {
								controlsName.push(thirdWithStepId.replace('INDEX_48_1', i));
							}
				const valuesThird: boolean[] = [];
				for (let i = 0; i < controlsName.length; i++) {
					valuesThird.push(this.isFrance(form.controls[map.get(controlsName[i])].value));
				}


				if (this.isFrance(firstCtrl.value) ||
				valuesSecond.indexOf(true) !== -1 ||
				valuesThird.indexOf(true) !== -1 ||
				this.isFrance(fourthCtrl.value) ||
				this.isFrance(fifthCtrl.value) ||
				this.isFrance(sixthCtrl.value)) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}

	isFrance(value): boolean{
		return value?(value.replace(/\s/g, '').toLowerCase() === 'france' ||
		 value.replace(/\s/g, '').toLowerCase() === 'fr' ||
		 value.replace(/\s/g, '').toLowerCase() === 'fra'):false;
	}
}
